import * as React from 'react';
import { connect } from 'react-redux';
import { IntelligentSinglePhotoUploadComponent } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion } from "../../../domain/questionnaireEvaluation";
import { getGPCTheme } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state)
    };
};
const IntelligentSinglePhotoUploadComponentWrapper = (props) => React.createElement(IntelligentSinglePhotoUploadComponent, Object.assign({}, props));
export const ConnectedIntelligentSinglePhotoUpload = connect(mapStateToProps)(IntelligentSinglePhotoUploadComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentSinglePhotoUpload.js.map